<template>
  <div>
    <div class="form-row">
      <div class='row'>
        <div class='col-10'>
          <img style="display:none;" id="bigpic" src="bigpic" class="car-image"/>
        </div>
        <div class='col-2' v-if='img_string=="關閉照片"'>
            <h3> <kbd>車牌號碼</kbd></h3>
            <input type="text" class="form-control" v-model="plt_no">
            <h3> <kbd>車別 </kbd></h3>
            <select name="" id="" class="form-control" v-model="carName">
              <option v-for="item in carTypes" :value="item.car_name">{{ item.car_name }}</option>
            </select>
            <!--<div class="custom-control custom-radio">
              <input v-model="carName" type="radio" class="custom-control-input" id="defaultGroupExample1" value="小型車">
              <label class="custom-control-label" for="defaultGroupExample1"><h5>小型車</h5></label>
            </div>
            <div class="custom-control custom-radio">
              <input v-model="carName" type="radio" class="custom-control-input" id="defaultGroupExample2" value="摩托車">
              <label class="custom-control-label" for="defaultGroupExample2"><h5>摩托車</h5></label>
            </div>
            <div class="custom-control custom-radio">
              <input v-model="carName" type="radio" class="custom-control-input" id="defaultGroupExample3" value="重型機車">
              <label class="custom-control-label" for="defaultGroupExample3"><h5>重型機車</h5></label>
            </div>
            <div class="custom-control custom-radio">
              <input v-model="carName" type="radio" class="custom-control-input" id="defaultGroupExample4" value="其它">
              <label class="custom-control-label" for="defaultGroupExample4"><h5>其它</h5></label>
            </div>-->
            <!--<button class="btn btn-primary" @click="updateCarName">更新</button>
            <div><br></div>-->
            <button class="btn btn-danger" @click="breakLaw" :disabled="this.$store.state.user.user.username=='estcheck'">確認認證</button>
        </div>
      </div>
      <button class="btn btn-primary" @click="showImg">{{img_string}}</button>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button class="btn btn-info" @click="uncertain" :disabled="this.$store.state.user.user.username=='estcheck'">無法開單</button>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button class="btn btn-success" @click="pass" :disabled="this.$store.state.user.user.username=='estcheck'">未違規</button>
    </div>
  </div>
</template>

<script>
import server from '@/config';

export default {
  name: 'CheckDetail',
  data() {
    return {
      status: null,
      sourceOfPicture: '',
      img_string: '顯示照片',
      carName: '汽車',
      carTypes: [],
      plt_no: '',
      randomNum: '',
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
  components: {
  },
  async mounted() {
    if (this.rowData.car_tp != null)
    {
      this.carName = this.rowData.car_tp.car_name;
    }
    if (this.rowData.plt_no != null)
    {
      this.plt_no = this.rowData.plt_no.plt_no;
    }
    var img = document.getElementById('bigpic')
    this.randomNum = Math.random();
    this.sourceOfPicture = `/media/interval/done/${this.rowData.fixed_link_code.fixed_link_code}/${this.rowData.img_filename}?t=${this.randomNum}`;
    this.img_string="關閉照片";
    img.src = this.sourceOfPicture;
    img.style.display = "block";
    img.class="car-image";  
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  async created() {
    await this.getCarType();
  },
  methods: {
    putIntoData(response, data) {
      response.data.forEach((item) => {
        this[data].push(item);
      });
    },
    getCarType() {
      return this.instance.get('/api/car-type/')
      .then((res) => {
        this.putIntoData(res, 'carTypes');
      });
    },
    showImg() {
      var img = document.getElementById('bigpic')
      this.randomNum = Math.random();
      this.sourceOfPicture = `/media/interval/done/${this.rowData.fixed_link_code.fixed_link_code}/${this.rowData.img_filename}?t=${this.randomNum}`;
      console.log(this.sourceOfPicture)
      if(img.style.display=="none")
      {
        this.img_string="關閉照片";
        img.src = this.sourceOfPicture;
        img.style.display = "block";
        img.class="car-image";
      }
      else
      {
        this.img_string="顯示照片";
        img.style.display = "none";
      }
    },
    breakLaw() {
      if(this.carName=='' || this.plt_no=='') {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '車號及車種資訊請勿空白',
        });
        return;
      }
      this.instance.patch(`/api/interval-speed-data/${this.rowData.id}/`, {
        xactno: this.rowData.xactno,
        status: "t1",
        user: this.$store.state.user.user.username,
        car_name: this.carName,
        plt_no: this.plt_no,
      })
      .then(() => {
        //this.$parent.refresh();
        /*this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功, 已認證',
        });*/
        this.$parent.refresh();
      })
      .catch((err) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data,
        });
      });
    },
    uncertain() {
      this.instance.patch(`/api/interval-speed-data/${this.rowData.id}/`, {
        xactno: this.rowData.xactno,
        status: "t3",
        user: this.$store.state.user.user.username,
        car_name: this.carName,
        plt_no: this.plt_no,
      })
      .then(() => {
        //this.$parent.refresh();
        /*this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });*/
        this.$parent.refresh();
      })
      .catch((err) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data,
        });
      });
    },
    pass() {
      this.instance.patch(`/api/interval-speed-data/${this.rowData.id}/`, {
        xactno: this.rowData.xactno,
        status: "t2",
        user: this.$store.state.user.user.username,
        car_name: this.carName,
        plt_no: this.plt_no,
      })
      .then(() => {
        //this.$parent.refresh();
        /*this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });*/
        this.$parent.refresh();
      })
      .catch((err) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data,
        });
      });
    },
    updateCarName() {
      this.instance.patch(`/api/interval-speed-data/${this.rowData.id}/`, {
        xactno: this.rowData.xactno,
        car_name: this.carName,
        plt_no: this.plt_no,
      })
      .then(() => {
        //this.$parent.refresh();
        /*this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });*/
        this.$parent.refresh();
      })
      .catch((err) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data,
        });
      });
    },
  },
};
</script>

<style lang="sass">
.car-image
  width: 100%
</style>



// WEBPACK FOOTER //
// CheckDetail.vue?06db5242